import React from "react";
import { useTranslation } from "react-i18next";

import ContactCard from "../../../components/v2/Contatos/ContactCard";
import Layout from "../../../components/v2/Layout";
import PageTitle from "../../../components/v2/PageTitle";
import { contactSectors } from "../../../content/contacts";

import style from "./styles.module.scss";

const keyI18n = "translations.contacts";

export default function Contatos() {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${keyI18n}.title`)}>
      <div className={style.body}>
        <PageTitle
          subtitle={t(`${keyI18n}.subtitle`)}
          title={t(`${keyI18n}.title`)}
        />

        <div className={style.list}>
          {contactSectors.map((sector) => (
            <ContactCard key={sector.slug} sector={sector} />
          ))}
        </div>
      </div>
    </Layout>
  );
}
